<div class="grid grid-cols-2 items-stretch gap-6">
	<div class="flex flex-col w-full space-y-6">
		<ui-section title="General Details">
			<div section-content>
				<app-closer-sync-general-details></app-closer-sync-general-details>
			</div>
		</ui-section>
		<app-closer-sync-lenders></app-closer-sync-lenders>
		<app-closer-sync-mortgage-funder
			[mortgage]="mortgage$ | async"
			*ngIf="(mortgage$ | async)?.syncFlowType === 'email'"
		></app-closer-sync-mortgage-funder>
	</div>
	<div class="flex flex-col w-full space-y-6">
		<app-mortgage-uploaded-documents
			title="Lender Documents"
			intercomDataTarget="sync-lender-documents-section"
			[systemTags]="['source:lender']"
			[mortgage]="mortgage$ | async"
		></app-mortgage-uploaded-documents>
		<ui-section
			title="Funding Details"
			data-intercom-target="closer-sync-funding-details"
		>
			<div section-content>
				<app-closer-sync-funding-details></app-closer-sync-funding-details>
			</div>
		</ui-section>
		<app-mortgage-broker [mortgage]="mortgage$ | async"></app-mortgage-broker>
		<app-mortgage-guarantors
			[allowAddEdit]="true"
			[matterMortgageId]="(mortgage$ | async)?.id"
		></app-mortgage-guarantors>
	</div>
</div>
